import React, { useEffect } from "react";

import { Tag, Icon } from "antd";
import Loading from "../../components/Assets/Loading.js";
import SearchResults from "../../components/Assets/SearchResults.js";
import BranchCard from "../../components/Assets/BranchCard.js";
import EmployeeCard from "../../components/Assets/EmployeeCard.js";
import { StatusRender } from "../../components/Assets/StatusRender.js";
import ContactLoader from "../../components/Assets/loaders/ContactLoader";
import EmployeeLoader from "../../components/Assets/loaders/EmployeeLoader";
import { getRedirectPath } from "../../util/Auth";

const EquipmentDetails = props => {
  const {
    fetchEquipmentDetails,
    fetchBranchDetails,
    fetchBranchEmployees,
    redux,
    fetchConditions,
    history
  } = props;

  const {
    loading,
    equipmentDetail,
    branchDetail,
    employees,
    employeesLoader,
    branchDetailLoader,
    branchMaster,
    contentLoader,
    conditions,
    detailsFromTable
  } = redux;

  useEffect(() => {
    fetchConditions();
  }, []);

  const { fleetNo, branchID, branchCode } = props.match.params;
  useEffect(() => {
    if (!detailsFromTable) {
      fetchEquipmentDetails(fleetNo, branchID);
    }
    fetchBranchDetails(branchID, branchCode);
    fetchBranchEmployees(branchID);
  }, [
    fleetNo,
    branchID,
    branchCode,
    fetchEquipmentDetails,
    fetchBranchDetails,
    fetchBranchEmployees,
    detailsFromTable
  ]);

  const {
    fldDesc,
    status,
    bookedPickupDate,
    bookedDeliveryDate,
    qtyAvail,
    available,
    terminated,
    reserved,
    catType,
    qtyOnHire,
    condition,
    description,
    regionCode
  } = equipmentDetail;

  const { address, divisionName, phone } =
    (typeof branchDetail !== "undefined" && branchDetail) || {};

  const employeeList = () => {
    if (employeesLoader) {
      return Array.apply(null, { length: 5 }).map((e, i) => (
        <EmployeeLoader key={i} />
      ));
    }

    const selectedEmployees = employees.filter(
      e => (e.role === "111" || e.role === "21") && e.branchCode === branchCode
    );
    if (selectedEmployees.length > 0) {
      return selectedEmployees.map((elem, index) => (
        <EmployeeCard
          key={`EmployeeCard${index}`}
          fldDesc={fldDesc}
          fleetNo={fleetNo}
          list={[
            { top: "Name", bottom: elem.description },
            { top: "Role", bottom: elem.roleName },
            {
              top: "Phone",
              bottom: elem.phoneNumber ? elem.phoneNumber : false,
              type: "phone"
            },
            {
              top: "Email",
              bottom: elem.email,
              type: "email",
              fldDesc,
              fleetNo
            },
            { top: "Mobile Phone", bottom: elem.mobile, type: "phone" }
          ]}
        />
      ));
    }
    return (
      <div className="noDataMessage">
        <h2>No contact information available from Baseplan</h2>
      </div>
    );
  };

  const branchInfo = () => {
    if (contentLoader) {
      return <ContactLoader />;
    }

    let cleanDivision = "";
    if (divisionName) {
      cleanDivision = divisionName.replace(/\b(\w*Rain for Rent\w*)/i, "");
      if (Number(cleanDivision.substring(0, 4))) {
        cleanDivision = cleanDivision.substring(4).replace("-", "");
      }
    }

    const list = [
      {
        top: "Division",
        bottom: divisionName ? cleanDivision : "No information available"
      },
      {
        top: "Phone",
        bottom: phone
          ? phone
          : branchMaster && branchMaster.phone
          ? branchMaster.phone
          : undefined,
        type: "phone"
      },
      {
        top: "Address",
        bottom: address
          ? address
          : branchMaster && branchMaster.address
          ? branchMaster.address
          : "No contact information is available please contact support."
      }
    ];
    if (catType === "SERIAL" && qtyAvail === qtyOnHire) {
      list.push({
        top: "Due Progress",
        type: "progress",
        bottom: "Progress not available"
      });
    }
    return (
      <>
        {branchDetail.isMain && (
          <Tag
            className="isMainTag"
            color="#003d79"
            style={{ width: "min-content", marginTop: "25px" }}
          >
            Main branch
          </Tag>
        )}
        <BranchCard
          list={list}
          bookedPickupDate={bookedPickupDate}
          bookedDeliveryDate={bookedDeliveryDate}
        />
      </>
    );
  };

  const content = () => {
    return (
      <>
        {branchDetailLoader ? (
          <Loading />
        ) : (
          <div className="ibox detailBox">
            <div
              onClick={() => history.push(getRedirectPath() || "/")}
              className="backButton"
            >
              <Icon type="arrow-left" />
              Back
            </div>
            <SearchResults
              headers={[
                {
                  key: "Equipment",
                  value: `${fleetNo} - ${fldDesc}`
                },
                {
                  key: "Branch",
                  value: `${branchCode} - ${description} `
                },
                {
                  key: "Region",
                  value: regionCode
                },
                {
                  key: "Status",
                  value: (
                    <StatusRender
                      terminated={terminated}
                      reserved={reserved}
                      status={status}
                      qtyAvail={qtyAvail}
                      available={available}
                      catType={catType}
                      qtyOnHire={qtyOnHire}
                      conditions={conditions}
                      condition={condition}
                    />
                  )
                }
              ]}
            />
            {branchInfo()}
            <br />
            {employeeList()}
          </div>
        )}
      </>
    );
  };

  return <>{loading && conditions ? <Loading /> : content()}</>;
};

export default EquipmentDetails;
